import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum } }) => {
        const { mode } = values;

        return `กรุณาอ่านส่วนที่แสดงออกมาดังๆ
                    ${mode === ModuleModeEnum.SELF ? 'เมื่อคลิกที่เนื้อเรื่อง ช่วงจะเลื่อนไป' : ''}`;
    },
    intro: {
        content: {
            loud: 'กรุณาอ่านส่วนที่แสดงออกมาดังๆ!',
            readingType1: 'มาอ่านแบบชี้แนะพร้อมกันทั้งหมดตาม{readingType}กันเถอะ',
            readingType2: 'มาอ่านแบบชี้แนะตาม{readingType}กันเถอะ',
            teacherAndStudents: 'คุณครูอ่านส่วนที่แสดงเป็นสีน้ำเงิน นักเรียนอ่านส่วนสีเหลืองออกมาดังๆ กันเลย!',
            start: 'มาเริ่มอ่านแบบชี้แนะตาม{readingType}กันไหม?',
            students: 'เพื่อน {students} ช่วยอ่านส่วนที่แสดงออกมาดังๆ นะ!',
        },
        othersCount: 'และอีก {count} คน',
    },
    options: {
        title: 'หัวข้อ',
        readingType: {
            label: 'หน่วยการอ่าน',
            unit: 'หน่วย',
            meaning: 'ความหมาย',
            sentence: 'ประโยค',
            paragraph: 'ย่อหน้า',
        },
        readingMode: {
            label: 'วิธีอ่าน',
            all: 'อ่านพร้อมกัน',
            split: 'แบ่งอ่านกับคุณครู',
            random: 'อ่านแบบสุ่ม',
            selected: 'อ่านแบบกำหนด',
        },
        example: {
            all: 'ทุกคนพร้อมกัน',
            teacher: 'คุณครู',
            students: 'นักเรียน',
        },
        textbook: 'เนื้อเรื่องจากหนังสือเรียน',
    },
    setting: {
        readerCount: 'จำนวนนักเรียนที่จะอ่าน',
        draw: 'สุ่ม',
        redraw: 'สุ่มใหม่',
        resetSelection: 'รีเซ็ตการเลือก',
        randomOrderNotice: 'ⓘ ลำดับจะถูกกำหนดแบบสุ่ม',
        connectedCount: 'เชื่อมต่อ {count} คน',
        personCount: '{count} คน',
        unit: 'คน',
    },
    inplay: {
        reading: 'กำลังอ่าน',
        readingCount: '{count} คน',
        fontDown: 'ก -',
        fontUp: 'ก +',
        me: 'ฉัน',
    },
    buttons: {
        next: 'เรียนต่อ',
        assign: 'กำหนดนักเรียน',
        assignStudents: 'จัดสรรนักเรียน',
        fontSize: 'ขนาดตัวอักษร',
    },
    result: {
        done: 'อ่านแบบชี้แนะเสร็จแล้ว!',

        lecture: {
            all: 'อ่านโดย "นักเรียนทั้งหมด" ตาม "หน่วย{readingType}"',
            split: 'แบ่งอ่านกับ "คุณครู" ตาม "หน่วย{readingType}"',
            random: '{students} อ่านตาม "หน่วย{readingType}"',
            selected: '{students} อ่านตาม "หน่วย{readingType}"',
            averageTime: 'ใช้เวลา {time}',
        },
        self: {
            all: 'นักเรียนทั้งหมดอ่านตาม{readingType}',
            split: 'แบ่งอ่านกับคุณครูตาม{readingType}',
            random: '{students} อ่านตาม{readingType}',
            selected: '{students} อ่านตาม{readingType}',
            averageTime: 'ใช้เวลาเฉลี่ย {time}',
            inplay: 'กำลังดำเนินการ "{readingMode}" ตาม "หน่วย{readingType}"',
        },
    },

    teacherFooter: {
        done: 'อ่านจบแล้ว',
        click: 'กรุณาคลิกที่พื้นที่เนื้อเรื่อง',
    },
    pageRange: 'หน้า {startPage}~{endPage}',
    modal: {
        random: {
            title: 'ไม่สามารถดำเนินการอ่านแบบผลัดกันได้',
            desc: 'เนื่องจากนักเรียนออกจากการเชื่อมต่อ จึงไม่สามารถดำเนินการ "อ่านแบบผลัดกัน (สุ่ม/กำหนด)" ได้ วิธีดำเนินการถูกรีเซ็ตเป็น "อ่านพร้อมกัน" แล้ว',
        },
    },
};
